import React from 'react'
import { ButtonSecondary } from '../../../../components/atoms'
import { Contact } from '../store/store'
import { useTranslation } from 'react-i18next'
import { RequestState } from '../../../types'
import slugify from 'react-slugify'

type Props = {
  contact: Contact
  removeContact: (contactId: string) => void
  onEdit: (contact: Contact) => void
}

function ContactRow(props: Props) {
  const { contact, removeContact, onEdit } = props
  const { t } = useTranslation(['global'])

  const deleteButtonText = contact.deleteRequestState === RequestState.Loading
    ? t('global:deleting')
    : t('global:delete')

  return (
    <tr data-cy={slugify(contact.name)}>
      <td data-cy="name">{contact.name}</td>
      <td data-cy="email">{contact.email}</td>
      <td data-cy="phone">{contact.phone}</td>
      <td data-cy="mobile">{contact.mobile}</td>
      <td className="align-right action-button-cell">
        <ButtonSecondary
          className="action-btn"
          data-cy="edit"
          onClick={() => onEdit(contact)}>
          {t('global:edit')}
        </ButtonSecondary>
        <ButtonSecondary
          className="action-btn"
          data-cy="delete"
          disabled={contact.deleteRequestState === RequestState.Loading}
          onClick={() => removeContact(contact.id)}>
          {deleteButtonText}
        </ButtonSecondary>
      </td>
    </tr>
  )
}

export default ContactRow
